import * as OpenReportingCreators from '../../../creators/OpenReporting.creators';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as React from 'react';
import { FormInput } from 'src/components/molecules';
import { LoginContainer } from './Login.styles';
import { FormInputVariant, FormState } from 'src/types';

interface PhoneNumberAndPinInputProps {
  setLoginPhoneNumber(
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void;
  setLoginPin(
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
  ): void;
  handleLogin: Function;
}

const PhoneNumberAndPinInput = (props: PhoneNumberAndPinInputProps) => {
  const { t } = useTranslation();
  return (
    <LoginContainer data-testid={'opr-login-container'}>
      <FormInput
        variant={FormInputVariant.INPUT}
        state={FormState.DEFAULT}
        label={t('public.CreatePublicReport.yourPhoneNumber')}
        placeholder={t('public.CreatePublicReport.phoneNumberPlaceholder')}
        onPaste={(
          e: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => props.setLoginPhoneNumber(e)}
        onChange={(
          e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => props.setLoginPhoneNumber(e)}
        data-testid="user-number"
        type="text"
        tooltipText={t('public.CreatePublicReport.phoneNumberTooltip')}
        tooltipWidth={'165px'}
      />
      <FormInput
        variant={FormInputVariant.INPUT}
        state={FormState.DEFAULT}
        label={t('public.CreatePublicReport.yourPin')}
        data-testid="user-pin"
        type="password"
        placeholder={t('public.CreatePublicReport.pinPlaceholder')}
        onKeyDown={(e) => e.key === 'Enter' && props.handleLogin()}
        onChange={(
          e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        ) => props.setLoginPin(e)}
      />
    </LoginContainer>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      ...OpenReportingCreators,
    },
    dispatch,
  );

export default connect(null, mapDispatchToProps)(PhoneNumberAndPinInput);
